import script from "./VideoUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoUploadDialog.vue?vue&type=style&index=0&id=3cd2f11c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd2f11c"]])

export default __exports__